export function bindDialog(dialog, onClose = null) {
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog || (event.target instanceof Element && event.target.closest('[data-dialog-close]'))) {
            dialog.close();
        }
    });

    if (onClose) {
        dialog.addEventListener('close', onClose);
    }
}
